import gsap from "gsap";

import { refreshScrollTriggers } from "./on-scroll-animations";

export const initTabs = (el) => {
  let activeTab = 0;

  let isAnimating = false;

  const tabTogglers = el.querySelectorAll(".js-tab-toggle");

  const tabs_wrapper = el.querySelector(".js-tabs");

  const tabs = el.querySelectorAll(".js-tabs__tab");

  const switchTab = (index) => {
    isAnimating = true;

    tabTogglers[activeTab].classList.remove("active");

    gsap.set(tabs_wrapper, { height: tabs_wrapper.offsetHeight });

    tabs[activeTab].classList.remove("active");

    gsap.set(tabs[activeTab], {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
    });

    gsap.delayedCall(0.3, () => {
      tabs[activeTab].removeAttribute("style");

      tabs[activeTab].classList.add("hidden");

      tabs[index].classList.add("active");
    });

    tabs[index].classList.remove("hidden");

    gsap.to(tabs_wrapper, {
      height: tabs[index].offsetHeight,
      onComplete: () => {
        isAnimating = false;

        activeTab = index;

        tabs_wrapper.removeAttribute("style");

        refreshScrollTriggers();
      },
    });

    tabTogglers[index].classList.add("active");
  };

  tabTogglers.forEach((button, tabIndex) => {
    button.addEventListener("click", () => {
      if (tabIndex != activeTab) {
        if (!isAnimating) {
          switchTab(tabIndex);
        }
      }
    });
  });
};
